import { workSheetConstants } from '../../_constants';

const initialState = { saveWorksheetLoading: true, data: '', error: false };

export function saveWorksheetReducer(state = initialState, action) {
    
    switch (action.type) {
        case workSheetConstants.REQUEST_SAVE_WORKSHEET:
            return {
                saveWorksheetLoading: true,
                data: '',
                error: false
            };
        case workSheetConstants.RECEIVE_SAVE_WORKSHEET:
            return {
                saveWorksheetLoading: false,
                data: action.saveWorksheet,
                error: false
            };
        case workSheetConstants.SAVE_WORKSHEET_ERROR:
            return {
                saveWorksheetLoading: false,
                data: '',
                error: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/workSheet/saveWorkSheet.reducer.js